import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../../services/api.service";
import { Task } from "@models/task";
import { Subscription } from "rxjs";
import { TaskService } from "../../../services/task.service";

@Component({
	selector: "app-client-task",
	templateUrl: "./client-task.component.html",
	styleUrls: ["./client-task.component.scss"],
})
export class ClientTaskComponent implements OnInit {
	tasks: Task[];
	sub: Subscription;

	constructor(private taskService: TaskService) {}

	ngOnInit() {
		this.sub = this.taskService.clientTaskChanges.subscribe(
			tasks => (this.tasks = tasks)
		);
	}

	ngOnDestroy() {
		if (this.sub) this.sub.unsubscribe();
	}

	submitTask(taskId: string, event: any) {
		const answers: string[] = event.answers;
		const replyOnly: boolean = event.replyOnly;
		return this.taskService.submitTask(taskId, answers, replyOnly);
	}
}
